import { UserDto } from 'common/dto/UserDto';
import { PermissionsType } from './Permissions';
import { Roles } from './Roles';

/**
 * Gestisce la logica di controllo dei permessi.
 */
export class PermissionLogic {
  /**
   * Controlla se il ruolo dell'utente da accesso al permesso richiesto.
   * In caso di più permessi,  controlla se il ruolo dell'utente
   * dà accesso ad **ALMENO UNO** dei permessi richiesti
   */
  static has(
    user: Maybe<UserDto>,
    permission: PermissionsType | PermissionsType[]
  ) {
    if (!user) return false;
    return true;
    // return Roles[user.role as any].hasPermission(permission);
  }
}
